import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export enum ClubAlbumStatus {
    Active = 1,
    Archived = 2
}

export const ClubAlbumStatusList = [
    { value: ClubAlbumStatus.Active, label: "Active" },
    { value: ClubAlbumStatus.Archived, label: "Archived" },
];

/** Where an album's photos live. Admins may only create or edit External albums. */
export enum ClubAlbumKind {
    Internal = 1,
    External = 2
}

export const ClubAlbumKindList = [
    { value: ClubAlbumKind.Internal, label: "In Elites" },
    { value: ClubAlbumKind.External, label: "External link" },
];

/** Chosen by whoever created the album; not derived from the URL. */
export enum ClubAlbumProvider {
    GoogleDrive = 1,
    GooglePhotos = 2,
    Other = 99
}

export const ClubAlbumProviderList = [
    { value: ClubAlbumProvider.GooglePhotos, label: "Google Photos" },
    { value: ClubAlbumProvider.GoogleDrive, label: "Google Drive" },
    { value: ClubAlbumProvider.Other, label: "Other" },
];

/** Absolute http/https only — the same rule the API and the app apply. */
export const isValidExternalAlbumUrl = (url?: string): boolean => {
    if (!url) return false;
    try {
        const parsed = new URL(url.trim());
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

export interface RunningClubAlbum {
    id: number;
    name: string;
    description?: string;
    coverImage?: string;
    status: ClubAlbumStatus;
    kind: ClubAlbumKind;
    externalUrl?: string;
    externalProvider?: ClubAlbumProvider;
    imageCount: number;
    pendingImageCount: number;
    createdAt: string;
    runningClub?: BaseLookupModel;
    runningClubEvent?: BaseLookupModel;
}

export class ClubAlbumPaginationFilterRequest extends PaginationFilterRequest {
    runningClubId?: number;
    runningClubEventId?: number;
    eventAlbumsOnly?: boolean;
}

/** No `kind` field: the API only lets admins manage external albums. */
export interface UpsertRunningClubExternalAlbum {
    id?: number;
    runningClubId?: number;
    runningClubEventId?: number;
    name?: string;
    description?: string;
    coverImage?: string;
    status: ClubAlbumStatus;
    externalUrl?: string;
    externalProvider?: ClubAlbumProvider;
}
